import { render, staticRenderFns } from "./BalancoEnergeticoView.vue?vue&type=template&id=2d067f3d&scoped=true"
import script from "./BalancoEnergeticoView.vue?vue&type=script&lang=js"
export * from "./BalancoEnergeticoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d067f3d",
  null
  
)

export default component.exports